"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statemint = void 0;
exports.statemint = {
    ChargeAssetTxPayment: {
        extrinsic: {
            tip: 'Compact<Balance>',
            // eslint-disable-next-line sort-keys
            assetId: 'Option<AssetId>'
        },
        payload: {}
    }
};
